import React from 'react';
import classnames from 'classnames';

import { Input, InputWrapper, LabelWrapper, RightButtonWrapper } from './TextInputStyles';
import PlayupThemeProvider from '../../themes/PlayupThemeProvider';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import useScreenQuery from '../../hooks/useScreenQuery';

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
	(
		{
			kind = 'blackslate',
			error,
			label,
			children,
			rightButton,
			rightButtonWidth,
			className,
			id,
			onWheel,
			editable = true,
			...rest
		},
		ref
	) => {
		const { isSmall } = useScreenQuery();
		const inputId = React.useMemo(() => id || `text-input-${Math.random()}`, [id]);

		return (
			<PlayupThemeProvider>
				<div className={className}>
					<LabelWrapper kind={kind} $isSmallScreen={isSmall}>
						{label && typeof label === 'string' ? <label htmlFor={inputId}>{label}</label> : label}
						{children}
					</LabelWrapper>
					<InputWrapper>
						<Input
							$editable={editable}
							kind={kind}
							$isSmallScreen={isSmall}
							ref={ref}
							id={inputId}
							buttonPadding={rightButtonWidth}
							className={classnames(error && 'error')}
							onWheel={(e) => {
								if (rest.type === 'number') e.currentTarget.blur();
								if (onWheel) onWheel(e);
							}}
							{...rest}
						/>
						{rightButton && <RightButtonWrapper>{rightButton}</RightButtonWrapper>}
					</InputWrapper>
					{error && <ErrorMessage textAlign={rest.errorTextAlign ?? 'center'}>{error}</ErrorMessage>}
				</div>
			</PlayupThemeProvider>
		);
	}
);

export default TextInput;

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	kind?: string;
	error?: string;
	label?: React.ReactElement | string;
	rightButton?: React.ReactNode;
	rightButtonWidth?: React.CSSProperties['width'];
	errorTextAlign?: 'center' | 'left';
	editable?: boolean;
}
